import { render, staticRenderFns } from "./AlunoCursoGeral.vue?vue&type=template&id=285cd5f4&"
import script from "./AlunoCursoGeral.vue?vue&type=script&lang=js&"
export * from "./AlunoCursoGeral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports